import {
    APPLICATION_DETAIL_FAILED,
    APPLICATION_DETAIL_LOADDATA,
    APPLICATION_DETAIL_LOADING,
    APPLICATION_DETAIL_SUCCESS
} from "../constants/ApplicationdetailConst";


export const success = (data) => {
    return {
        type: APPLICATION_DETAIL_SUCCESS,
        data
    }
};

export const failed = () => {
    return {
        type: APPLICATION_DETAIL_FAILED
    }
};

export const loading = () => {
    return {
        type: APPLICATION_DETAIL_LOADING
    };
};

export const loaddata = (id) => {
    return {
        type: APPLICATION_DETAIL_LOADDATA,
        id

    };
};

